import type { Overview } from "../types";
import { api } from "./core";

export const overviewApi = {
  overview: (groupId: string) => api<Overview>("/overview", { groupId }),
};
